import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { FaRegFrown, FaRegSmileBeam } from 'react-icons/fa';

import { __t } from '@mssgme/shared';
import { LandingsPropTypes, LinkBlank } from '@mssgme/ui';
import { useCoreContext, useCRMData, useModalThemes, useViewOrder } from '../hooks';
import { ThemedButton, ThemedModal } from '../UI';
// import { OrderItemsList } from './OrderItem';

import styles from './PaymentStatusPage.scss';

PaymentStatusPage.propTypes = {
    orderId: PropTypes.string.isRequired,
    status: LandingsPropTypes.orderStatus.isRequired,
};

function PaymentStatusPage({ orderId, status }) {
    const history = useHistory();
    const { router } = useCoreContext();
    const { form } = useCRMData();
    const { contentStyle } = useModalThemes();
    const { order, error } = useViewOrder(orderId);
    const resolvedStatus = status === 'pending' ? 'paid' : status;

    const handleClose = useCallback(
        (to) => {
            if (to === 'toOrder') {
                return history.push(router.userOrders.toOrder(orderId));
            }

            return history.push(router.toHome());
        },
        [router]
    );

    if (error) {
        return (
            <ThemedModal overlay compact showHeader={false} onClose={handleClose}>
                <div className={styles.root}>
                    <p>{__t('order_not_found')}</p>
                </div>
            </ThemedModal>
        );
    }

    return (
        <ThemedModal overlay compact showHeader={false} onClose={handleClose}>
            {(onClose) => (
                <div className={styles.root}>
                    {resolvedStatus === 'failed' ? (
                        <FaRegFrown size={60} className={styles.icon} />
                    ) : (
                        <FaRegSmileBeam size={60} className={styles.icon} />
                    )}

                    <h1 className={styles.title}>{__t(`payment_${resolvedStatus}`)}</h1>
                    {resolvedStatus !== 'failed' && (
                        <>
                            <p className={styles.subTitle}>{form.successMessage || __t('payment_paid_subtitle')}</p>
                            {form.successURL?.url && (
                                <p className={styles.subTitle}>
                                    <LinkBlank href={form.successURL.url}>
                                        {form.successURL.title || form.successURL.url}
                                    </LinkBlank>
                                </p>
                            )}
                        </>
                    )}

                    {/*<h2 className={styles.orderTitle}>{__t('order_adjusting')}</h2>*/}
                    {/*{order && <OrderItemsList order={order} />}*/}

                    <ThemedButton
                        fullWidth
                        style={{ marginTop: 16 }}
                        theme={contentStyle}
                        onClick={() => onClose('toOrder')}
                    >
                        {__t('view_order')}
                    </ThemedButton>
                    <ThemedButton
                        fullWidth
                        style={{ marginTop: 8 }}
                        contour
                        theme={contentStyle}
                        onClick={() => onClose('toHome')}
                    >
                        {__t('back_to_home')}
                    </ThemedButton>
                </div>
            )}
        </ThemedModal>
    );
}

export default PaymentStatusPage;
